/**
 * @generated SignedSource<<b5cc4095bda196b82245927dab850b5c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type keyboardShortcuts_issueViewWatchers_KeyboardShortcutsRelay$data = {
  readonly fieldId: string;
  readonly id: string;
  readonly type: string;
  readonly watch: {
    readonly $updatableFragmentSpreads: FragmentRefs<"useWatchesMutation_Mutation_Updatable">;
    readonly count: AGG$Long | null | undefined;
    readonly isWatching: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "keyboardShortcuts_issueViewWatchers_KeyboardShortcutsRelay";
};
export type keyboardShortcuts_issueViewWatchers_KeyboardShortcutsRelay$key = {
  readonly " $data"?: keyboardShortcuts_issueViewWatchers_KeyboardShortcutsRelay$data;
  readonly " $fragmentSpreads": FragmentRefs<"keyboardShortcuts_issueViewWatchers_KeyboardShortcutsRelay">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "keyboardShortcuts_issueViewWatchers_KeyboardShortcutsRelay",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "concreteType": "JiraWatch",
      "kind": "LinkedField",
      "name": "watch",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isWatching"
        },
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "FragmentSpread",
          "name": "useWatchesMutation_Mutation_Updatable"
        }
      ]
    }
  ],
  "type": "JiraWatchesField"
};

(node as any).hash = "f1be862741c67b7fc547ba24ebdaf51a";

export default node;
